import { render, staticRenderFns } from "./traitsTable.vue?vue&type=template&id=6fe5250e&"
import script from "./traitsTable.vue?vue&type=script&lang=js&"
export * from "./traitsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard})
